import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { DataGrid, Button } from "devextreme-react";
import { Column, RemoteOperations, Paging, Pager } from "devextreme-react/ui/data-grid";
import { doGetFiltrosBaterias, openCloseModalEditarBateria, openCloseModalEliminarBateria, doGetBaterias, getExamsList, doGetBateria } from "./action";
import TableFilter from "../../../../Shared/tableFilter";
import { filterType } from "../../../../../helpers/filterHelper";
import ModalEditar from "./modalEditar";
import EmptyIcon from "../../../../Shared/EmptyIcon";
import ModalDelete from "./modalDelete";
import ModalDesactivar from "./modalDesactivar";
import validaciones from "../../../../../helpers/validaciones";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";

class Baterias extends React.PureComponent {
  constructor(props) {
    super(props);

    this.tableRef = React.createRef();
    if (!this.props.filtrosBaterias) this.props.dispatch(doGetFiltrosBaterias());
    this.props.dispatch(doGetBaterias(null, true));
    this.props.dispatch(getExamsList());
  }

  handleAdd = () => {
    this.props.dispatch(openCloseModalEditarBateria(true, {}, true));
  }

  handleEdit = (e) => {
    this.props.dispatch(doGetBateria(e.data.Id));
  }

  handleDelete = (e) => {
    this.props.dispatch(openCloseModalEliminarBateria(true, e.data));
  }

  handleFilterChange = (text, filters) => {
    const currentFilters = [...filters];
    if (text) currentFilters.push({ column: "Description", value: { text, value: text }, type: filterType.search });
    this.props.dispatch(doGetBaterias(currentFilters));
  }

  render() {
    return (
      <React.Fragment>
        <ModalEditar />
        <ModalDelete />
        <ModalDesactivar />
        {this.props.isLoading && <LoadingOverlay />}
        <TableFilter
          placeholder="Buscar batería"
          onChange={this.handleFilterChange}
          filters={this.props.filtrosBaterias}
          show
          buttons={{
            filter: { buttonName: "iconFilter", visible: true, buttonAction: null },
            document: { buttonName: "iconDocument", visible: false, buttonAction: null },
            download: { buttonName: "iconDownload", visible: false, buttonAction: null },
            newItem: {
              buttonName: "custom", visible: true, buttonAction: this.handleAdd, buttonText: "Agregar batería",
            },
          }}
        />
        <DataGrid
          dataSource={this.props.listaBateriasFiltradas}
          noDataText=""
          className="custom-table"
          showBorders={false}
          showColumnLines={false}
          allowColumnResizing={false}
          columnAutoWidth={false}
          showRowLines={false}
          rowAlternationEnabled
          onContentReady={(e) => {
            if (e.component.totalCount() === 0) {
              const config = {};
              config.addClass = "table-margin";
              const noDataSpan = e.component.element().querySelector(".dx-datagrid-nodata");
              const element = validaciones.noDataDOMElement(config, "Sin baterias");
              noDataSpan.appendChild(element);
            }
          }}
        >

          <Column
            dataField="Description"
            allowSearch
            caption="Nombre"
            cellTemplate={(element, row) => {
              ReactDOM.render(
                <div className="group-Column-inline">
                  <EmptyIcon size={13} full={row.data.Status} />
                  <div className="text space-text"> {row.data.Description}</div>
                </div>
                , element
              );
            }}
          />

          <Column
            alignment="center"
            dataField="ExamsCount"
            caption="Prestaciones"
            calculateDisplayValue={(data) => `${data.ExamsCount}`}
          />

          <Column
            caption=""
            alignment="right"
            cellTemplate={(element, row) => {
              ReactDOM.render(
                <div className="button-column">
                  <Button
                    className="slimButton"
                    type="success"
                    style={{ marginRight: 5 }}
                    text="Editar"
                    onClick={() => this.handleEdit(row)}
                  />
                  <Button
                    disabled={row.data.Status === 1}
                    className="slimButton"
                    type="danger"
                    text="Eliminar"
                    onClick={() => this.handleDelete(row)}
                  />
                </div>

                , element
              );
            }}
          />

          <RemoteOperations
            paging={false}
            filtering
            summary={false}
            groupPaging={false}
            grouping={false}
            sorting={false}
          />

          <Paging
            defaultPageSize={10}
          />

          <Pager
            showNavigationButtons
            showInfo
            infoText={(page, total) => `Página ${page} de ${total}`}
          />

        </DataGrid>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.mantenedorBaterias.isLoading,
  listaBaterias: state.mantenedorBaterias.listaBaterias,
  listaBateriasFiltradas: state.mantenedorBaterias.listaBateriasFiltradas,
  filtrosBaterias: state.mantenedorBaterias.filtrosBaterias,
  tiposBateria: state.mantenedorBaterias.tiposBateria,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(Baterias);
